var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "Registers",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpBox",
                { attrs: { direction: "column" } },
                [
                  _vm.items.length
                    ? _c(
                        "ItpBox",
                        [
                          _c("ItpFormSelect2", {
                            staticClass: "w-50",
                            attrs: {
                              name: "register",
                              "bind-object": "",
                              valueField: "id",
                              textField: "name",
                              options: _vm.items
                            },
                            model: {
                              value: _vm.selectedRegister,
                              callback: function($$v) {
                                _vm.selectedRegister = $$v
                              },
                              expression: "selectedRegister"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "DIV",
                            { staticClass: "ml-3" },
                            [
                              _c("ItpButton", {
                                attrs: {
                                  text: _vm._f("pgettext")(
                                    "Add register...",
                                    "Registers"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.evh_3054425420812800_clickPreventStop(
                                      $event,
                                      {}
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.items.length === 0 && !_vm.createRegister
                    ? _c(
                        "ItpBox",
                        {
                          attrs: { direction: "column", alignItems: "center" }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("pgettext")(
                                    "No registers have been added yet.",
                                    "Registers"
                                  )
                                ) +
                                "\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpButton", {
                            attrs: {
                              variant: "primary",
                              text: _vm._f("pgettext")(
                                "Create register...",
                                "Registers"
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_814138253067422_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.createRegister || _vm.selectedRegister
                    ? _c("hr", { staticClass: "w-100" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.createRegister || _vm.selectedRegister
                    ? _c("UcRegister", {
                        attrs: {
                          oid: _vm.createRegister
                            ? null
                            : _vm.selectedRegister.id
                        },
                        on: {
                          saved: function($event) {
                            return _vm.evh_3774018224472797_saved($event, {})
                          },
                          deleted: function($event) {
                            return _vm.evh_3774018224472797_deleted($event, {})
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1548630417156826_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }